export default "__VITE_ASSET__BoPUaxoN__"